import { useCallback, useEffect, useState } from 'react';
import {
  applyNativeDisplayDensityToDocument,
  loadNativeDisplayDensity,
  saveNativeDisplayDensity,
  type NativeDisplayDensity,
} from '../utils/nativeDisplayPreferences';
import { isNativeShell } from '../utils/distribution';

export function useNativeDisplayPreferences() {
  const nativeShell = isNativeShell();
  const [density, setDensityState] = useState<NativeDisplayDensity>(() =>
    nativeShell ? loadNativeDisplayDensity() : 'comfortable',
  );

  useEffect(() => {
    if (!nativeShell) return;
    applyNativeDisplayDensityToDocument(density);
  }, [density, nativeShell]);

  const setDensity = useCallback(
    (nextDensity: NativeDisplayDensity) => {
      if (!nativeShell) return;
      setDensityState(nextDensity);
      saveNativeDisplayDensity(nextDensity);
      applyNativeDisplayDensityToDocument(nextDensity);
    },
    [nativeShell],
  );

  return {
    density,
    setDensity,
    isNativeShell: nativeShell,
  };
}
